import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import { GetQuoteComments } from "../../../vlp/services/QuotesService";



export default function QuoteCommentSelectorDialog({
  open,
  onClose,
  onSelectComment,
}) {
  const [loading, setLoading] = useState(false);
  const [commentTypes, setCommentTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [commentValue, setCommentValue] = useState("");

  useEffect(() => {
    if (open) {
      loadComments();
      setSelectedType("");
      setCommentValue("");
    }
  }, [open]);

  const loadComments = async () => {
    setLoading(true);
    try {
      const response = await GetQuoteComments();
      if (response && response.results) {
        const data = response.results;

        // Convert object → array
        const list = [
          {
            CommentType: "Drinking Water",
            CommentValue: data.drinkingWaterComment || "",
          },
          {
            CommentType: "Waste Water",
            CommentValue: data.wasteWaterComment || "",
          },
          {
            CommentType: "Generic",
            CommentValue: data.genericComment || "",
          },
        ];

        setCommentTypes(list);
      }

    } catch (err) {
      NotificationManager.error("Unable to load quote comments");
    }
    setLoading(false);
  };


  const handleTypeChange = (e) => {
    const type = e.target.value;
    setSelectedType(type);

    const selected = commentTypes.find(
      (x) => x.CommentType === type
    );
    setCommentValue(selected ? selected.CommentValue : "");
  };

  const handleApply = () => {
    if (!selectedType) {
      NotificationManager.error("Please select a comment type");
      return;
    }
    onSelectComment(commentValue); // return text to parent
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select Quote Comment</DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
              padding: 3,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <InputLabel>Select Comment Type</InputLabel>
              <Select
                value={selectedType}
                onChange={handleTypeChange}
                label="Select Comment Type"
              >
                {commentTypes.map((item) => (
                  <MenuItem
                    key={item.CommentType}
                    value={item.CommentType}
                  >
                    {item.CommentType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Comment"
              value={commentValue}
              fullWidth
              multiline
              minRows={6}
              sx={{ mt: 2 }}
              disabled
            />
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleApply} variant="contained">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}
